import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static classes = ['updated']

  initialize = () => {
    this.setDefaultBackground()
  }

  setDefaultBackground = () => {
    const body = document.querySelector('body')
    body.classList.remove('default-bg')
    body.classList.add(this.updatedClass)
  }
}
